export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const getString = (value: unknown): string | undefined =>
  typeof value === 'string' ? value : undefined;

export const getBoolean = (value: unknown): boolean | undefined =>
  typeof value === 'boolean' ? value : undefined;

/** Try each key in order and return the first value that is an array. */
export const findFirstArray = (
  obj: Record<string, unknown>,
  keys: string[]
): unknown[] | undefined => {
  for (const key of keys) {
    const candidate = obj[key];
    if (Array.isArray(candidate)) {
      return candidate;
    }
  }
  return undefined;
};

export const toTitleCase = (value: string): string =>
  value
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/^\w/, (char) => char.toUpperCase());

export const slugify = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
